import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export type CommentDataProps = {
    c_list_no: number;
    c_content: string;
    c_wdate: string;
    c_name: string;
};

interface DetialRequest {
    list_no: string;
}

export interface DetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    list_no: number;
    company: string;
    name: string;
    mobile: string;
    address: string;
    printer: string;
    w_date: string;
    result: number;
    result_text: string;
    comment: CommentDataProps[];
    // };
}

export const useGetConsoleQrSystemDetail = ({ list_no }: DetialRequest): UseQueryResult<DetailResponse, Error> => {
    let url = enum_api_uri.get_console_qr_system_request_detail.replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleQrSystemDetail", list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!list_no,
    });
};
